import { render, staticRenderFns } from "./MaterialComeDown.vue?vue&type=template&id=ea455ba0&scoped=true&"
import script from "./MaterialComeDown.vue?vue&type=script&lang=js&"
export * from "./MaterialComeDown.vue?vue&type=script&lang=js&"
import style0 from "./MaterialComeDown.vue?vue&type=style&index=0&id=ea455ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea455ba0",
  null
  
)

export default component.exports